import { Button, Popover, StatusIndicator } from '@awsui/components-react';
import React from 'react';

const copyToClipboard = (content) => {
  navigator.clipboard.writeText(content).then(
    () => {
      return true;
    },
    () => {
      return false;
    },
  );
};

const handleCopyClick = (contentToCopy) => {
  if (contentToCopy) {
    copyToClipboard(contentToCopy);
  }
};

// eslint-disable-next-line
export const CopyButton = ({ data, disabled }) => (
  <Popover
    size="small"
    position="bottom"
    triggerType="custom"
    dismissButton={false}
    content={<StatusIndicator type="success">Copied</StatusIndicator>}
  >
    <Button disabled={disabled} ariaLabel="copy" iconName="copy" onClick={() => handleCopyClick(data)}>
      Copy
    </Button>
  </Popover>
);
